import React from "react";
import { Route } from "react-router";
import CustomQuoteLandingPage from "pages/CustomQuote/CustomQuoteLandingPage/CustomQuoteLandingPage";
import CreateQuotePage from "pages/CustomQuote/CreateQuotePage/CreateQuotePage";
import { CustomQuoteDetailPage } from "pages/CustomQuote/CustomQuoteDetailPage/CustomQuoteDetailPage";
import AddQuotePage from "pages/CustomQuote/AddQuotePage/AddQuotePage";
import { CustomQuoteConfirmationPage } from "components/CustomQuote/CustomQuoteConfirmationPage/CustomQuoteConfirmationPage";
import { ProtectedRoute } from "routes/ProtectedRoute";
import { UserRole } from "types/declarations/enums.ts";

export const CustomQuotesRoutes = ProtectedRoute({
	path: "custom-quote",
	featureFlag: "customQuoteEnabled",
	userRolesWithAccess: [UserRole.USER, UserRole.QUOTER, UserRole.SALES, UserRole.INTERNAL_DESIGNER],
	children: (
		<>
			<Route
				index
				element={<CustomQuoteLandingPage />}
			/>
			<Route
				path="create-quote"
				element={<CreateQuotePage />}
			/>
			<Route
				path=":quoteId"
				element={<CustomQuoteDetailPage />}
			/>
			<Route
				path=":quoteId/add-quote"
				element={<AddQuotePage />}
			/>
			<Route
				path="confirmation/:quoteId"
				element={<CustomQuoteConfirmationPage />}
			/>
		</>
	)
});
